import { useTranslation } from "react-i18next";
import { Button } from "antd";

const VideoRecorder = ({ data }: any) => {
  const { t } = useTranslation();
  return <div className="center">{t("Câu hỏi tự luận", "Câu hỏi tự luận")}</div>;
};

export default VideoRecorder;
